import { ResPostSlug } from '~/types/types';
import { Route } from './+types/$slug'
import { httpServerCMS } from '~/lib/axiosServer';
import SectionChild from '~/components/SectionChild';
import { useLoaderData } from 'react-router';
import dayjs from 'dayjs';
import SetInnerHTML from '~/components/SetInnerHTML';
import BreadcrumbPageCus from '~/components/breadcrumb-page';
import Tags from '~/components/tags';
import { invariantResponse } from '@epic-web/invariant';
import { GeneralErrorBoundary } from '~/components/error-boundary';
import NewsCard from './../__components/news-card';
import { buildCanonicalLink, buildMetaFromLoader, buildSeoMeta, getOrigin } from '~/utils/seo';

import { hostName } from '~/utils/format';


export async function loader({ params, request }: Route.LoaderArgs) {
  const { slug } = params;
  const data = await httpServerCMS
    .get<ResPostSlug>(`/v1/posts/slug/${slug}`)
    .then((res) => res.data)
    .catch(() => null);
  invariantResponse(data, "Không tìm thâý bài viết", { status: 404 });
  const origin = getOrigin(request);
  const url = new URL(request.url);
  const canonicalUrl = origin ? `${origin}${url.pathname}` : url.pathname;
  return {
    ...data,
    seo: {
      canonical: canonicalUrl,
      ...data.post.seo,
    },
  };
}

function DetailPost() {
  const data = useLoaderData<typeof loader>()
  return (
    <div>
      <SectionChild className="pb-20 bg-white">
        <div className="flex flex-col gap-8 mt-8 md:flex-row">
          <div className="flex-1">
            <BreadcrumbPageCus title={data.post.title} />
            <div className="flex flex-wrap gap-2 py-5">
              <div className="flex items-center flex-1 gap-x-2 text-gray">
                <Tags text={data.post.parentCategory.name} />
                <div className="font-normal capitalize">
                  {dayjs(new Date(data.post.publishedAt || data.post.updatedAt))
                    .locale("vi")
                    .format("dddd DD/MM/YYYY")}
                </div>
              </div>
            </div>
            <SetInnerHTML
              content={data.post.content}
              title={data.post.title}
              description={data.post.description}
            />
          </div>
          <div className="md:w-[324px]">
            <div className="title-tabs title-small">
              <h3 className="text-2xl">Bài viết liên quan</h3>
            </div>
            <div className="mt-8 space-y-4">
              {data.relatedPosts.map((item) => {
                return <NewsCard data={item} key={item.id} />;
              })}
            </div>
          </div>
        </div>
      </SectionChild>
    </div>
  );
}

export default DetailPost

export const meta = (args: Route.MetaArgs) =>
  {

    return buildMetaFromLoader(
      args,
      {
        hostName,
        buildSeoMeta,
        defaultImage: "/image/landing_page/Banner_1.png",
      },
      (ld) => ld?.seo
    );
  }
 ;

export const handle = {
  dynamicLinks: (props: any) => {
    return buildCanonicalLink(props?.data?.seo?.canonical || "");
  },
};
export function ErrorBoundary() {
  return (
    <GeneralErrorBoundary
      statusHandlers={{
        404: () => (
          <p>Không tìm thấy bài viết</p>
        ),
      }}
    />
  );
}
